export const useSizebayCountry = () => {
  const { country } = useRouteHelper()

  const uppercaseCountry = country.toUpperCase()
  const sizebayCountry = ref<any>('')
  if (['IT', 'FR', 'US', 'JP'].includes(uppercaseCountry)) {
    sizebayCountry.value = uppercaseCountry
  } else if (uppercaseCountry === 'GB') {
    sizebayCountry.value = 'UK'
  } else {
    sizebayCountry.value = 'EU'
  }

  return {
    sizebayCountry,
  }
}
